<template>
  <div>
    <HeroSection />
    <BenefitsSection />
    <ComplianceSection />
    <FeaturesSection />
    <PricingSection />
    <TestimonialsSection />
    <GallerySection />
    <FaqSection />
  </div>
</template>

<script>
// @ is an alias to /src
import HeroSection from '@/components/HeroSection.vue'
import BenefitsSection from '@/components/BenefitsSection.vue'
import FeaturesSection from '@/components/FeaturesSection.vue'
import PricingSection from '@/components/PricingSection.vue'
import TestimonialsSection from '@/components/TestimonialsSection.vue'
import GallerySection from '@/components/GallerySection.vue'
import ComplianceSection from '@/components/ComplianceSection.vue'
import FaqSection from '@/components/FaqSection.vue'
import { useHead } from '@vueuse/head'

export default {
  name: 'HomeView',
  components: {
    HeroSection,
    BenefitsSection,
    FeaturesSection,
    PricingSection,
    TestimonialsSection,
    GallerySection,
    ComplianceSection,
    FaqSection 
  },
  setup() {
    useHead({
      title: 'Medicynia - Gestión Clínica',
      meta: [
        { name: 'description', content: 'Medicynia es una plataforma SaaS para médicos en México. Gestiona expedientes clínicos, agenda, notas médicas y cumple con la NOM-004-SSA3-2012 de forma simple y segura.' },
        { name: 'keywords', content: 'expediente clínico, SaaS, médicos, agenda médica, notas médicas, NOM-004, gestión clínica, software médico, salud, México' },
        { property: 'og:title', content: 'Medicynia - Gestión Clínica' },
        { property: 'og:description', content: 'Plataforma para médicos que simplifica la gestión de consultorios y expedientes clínicos en México.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://medicynia.com/' },
        { property: 'og:image', content: 'https://medicynia.com/logo-main.webp' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Medicynia - Gestión Clínica' },
        { name: 'twitter:description', content: 'Plataforma para médicos que simplifica la gestión de consultorios y expedientes clínicos en México.' },
        { name: 'twitter:image', content: 'https://medicynia.com/logo-main.webp' }
      ],
      link: [
        { rel: 'canonical', href: 'https://medicynia.com/' }
      ]
    })
  }
}
</script>

<style scoped>
/* No specific styles needed here as layout is handled by Bootstrap in child components */
</style>
